import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
    setAmountError,
    setNameError,
    setStartDateError,
    setEndDateError,
    setTypeError,
} from '../../../features/createBudget/createBudgetSlice';
import moment from 'moment';

export const useBudgetValidation = () => {
    const dispatch = useDispatch();

    const validateAmount = useCallback((amount) => {
        if (!amount) {
            dispatch(setAmountError('Please provide a budget amount'));
            return false;
        } else if (amount.toString().length > 8) {
            dispatch(
                setAmountError('Please provide a budget amount less than 8 digits'),
            );
            return false;
        }
        return true;
    }, [dispatch]);

    const validateName = useCallback((name) => {
        if (!name) {
            dispatch(setNameError(true));
            return false;
        }
        return true;
    }, [dispatch]);

    const validateCustomBudgetFields = useCallback((start_date, end_date, type) => {
        let isValid = true;

        if (!start_date) {
            dispatch(setStartDateError(true));
            isValid = false;
        }
        if (!end_date) {
            dispatch(setEndDateError(true));
            isValid = false;
        }
        if (!type) {
            dispatch(setTypeError(true));
            isValid = false;
        }

        return isValid;
    }, [dispatch]);

    const validateDateRange = useCallback((start_date, end_date) => {
        const daysDifferent = moment(end_date).diff(moment(start_date), 'days');
        if (daysDifferent < 2) {
            dispatch(setStartDateError(true));
            dispatch(setEndDateError(true));
            return false;
        }
        return true;
    }, [dispatch]);

    const validateForm = useCallback((formData, tab) => {
        const { amount, name, start_date, end_date, type } = formData;

        if (tab === 'monthly' || tab === 'weekly') {
            return validateAmount(amount) && validateName(name);
        }

        if (tab === 'custom') {
            const basicValidation = validateAmount(amount) && validateName(name);
            const customValidation = validateCustomBudgetFields(start_date, end_date, type);
            const dateRangeValidation = validateDateRange(start_date, end_date);

            return basicValidation && customValidation && dateRangeValidation;
        }

        return false;
    }, [validateAmount, validateName, validateCustomBudgetFields, validateDateRange]);

    return {
        validateAmount,
        validateName,
        validateCustomBudgetFields,
        validateDateRange,
        validateForm,
    };
};